import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { MatDialog } from "@angular/material";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NavigationEnd, Router } from "@angular/router";
import { Breakpoints, MediaMatcher } from "@angular/cdk/layout";
import { FinanciamientoApiService } from "src/app/services/financiamiento-reusable.service";
import * as moment from 'moment';
import { Globals } from "src/app/globals";
import { VisorDocumentosComponent } from "../visor-documentos/visor-documentos.component";
import { ToastrService } from "ngx-toastr";
import { I } from "ng-zorro-antd";
import { DialogoConfirmacionComponent } from "../dialogo-confirmacion/dialogo-confirmacion.component";

@Component({
  selector: "app-consulta-tramite",
  templateUrl: "./consulta-tramite.component.html",
  styleUrls: ["./consulta-tramite.component.scss"],
})
export class ConsultaTramiteComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  flagEnviarRechazado: boolean=false;
  flagImpresion: boolean=false;
  flagDisabledBoton: boolean=false;
  suministro: any;
  width = "70%";
  showSuministro = true;
  navigationSubscription;
  mobileQuery: MediaQueryList;

  data: any;
  dataLocal: any;
  telefono: string = "";
  celular: string = "";
  correo: string = "";
  codOficina: string="";
  parentesco: string = "";
  nro_sumininstro: string = "";
  nombres: string = "";
  apellidos: string = "";
  tipo_documento: string = "";
  descTipodocumento: string ="";
  desc_tip_docum: string = "";
  nro_documento: string = "";
  correo_solicitante: string = "";
  flagBoton: boolean = false;
  flag: boolean = false;
  titulo: string = "";
  mensaje: string = "";
  nombreArchivoConvenio: string ='';
  idBandeja: number;
  returnDialog: boolean = false;

  filesMap: Map<number, any> = new Map<number, any>();
  controls: any[] = [];
  displayedColumns: string[] = [
    "item",
    "tipo_documento",
    "documento_adjunto",
    "adjuntar",
    "eliminar",
    "ver",
  ];
  dataSource: any[] = [];
  nombresArchivosTemp: any[] = [];
  verDocumentos: boolean = false;
  historicoTramites: any [] = [];
  estadoTramite: string = '';
  private _mobileQueryListener: () => void;
  limitFile_pdf: string='';
  limitFile_jpg: string='';
  //disabledActions: boolean = false;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    public changeDetectorRef: ChangeDetectorRef,
    private toastr: ToastrService,
    public media: MediaMatcher,
    private globals: Globals,
    public financiamiento_service: FinanciamientoApiService
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd && this.showSuministro === false) {
        this.showSuministro = true;
        this.ngOnInit();
      }
    });
  }

  ngOnInit() {

    this.data = JSON.parse (localStorage.getItem ('data'));
    this.nro_sumininstro = this.data.suministro;
    this.nombres         = this.data.nombres;
    this.apellidos       = this.data.apellidos;
    this.desc_tip_docum  = this.data.desc_tipo_docu;
    this.tipo_documento  = this.data.tipo_documento;
    this.nro_documento   = this.data.numero_documento;
    this.parentesco      = this.data.parentesco;
    this.telefono        = this.data.telefono;
    this.celular         = this.data.celular;
    this.correo          = this.data.correo;
    this.codOficina      = this.data.codOficina;

    this.loadValidaConsultaTramite();

  }



  cargarData() {

    console.log('##CARGAR DATA##');
    console.log('this.data.suministro',String(this.data.suministro));
    console.log('this.tipo_documento',this.tipo_documento);
    console.log('this.nro_documento',this.nro_documento);

    this.financiamiento_service
      //.consultaEstado("5142526", "TD001", "04049278")
      .consultaEstado(String(this.data.suministro), this.tipo_documento, this.nro_documento, this.idBandeja)
      .toPromise()
      .then((res: any) => {
        if (res.estado === 'OK') {
          this.nro_sumininstro = res.resultado.estadoTramite.sumistro;
          this.nombres = res.resultado.estadoTramite.nombresSolicitante;
          this.apellidos = res.resultado.estadoTramite.paternoSolicitante + ' ' + res.resultado.estadoTramite.maternoSolicitante;
          this.tipo_documento = res.resultado.estadoTramite.tipoDocumento;
          this.descTipodocumento = res.resultado.estadoTramite.descTipodocumento;
          this.nro_documento = res.resultado.estadoTramite.numDocumento;
          this.correo_solicitante=res.resultado.estadoTramite.correoSolicitante;
          this.idBandeja=res.resultado.estadoTramite.idBandeja;
          this.historicoTramites = res.resultado.historicoTramites.reverse ();
          this.estadoTramite = res.resultado.estadoTramite.estadoTramite;
          this.nombreArchivoConvenio=res.resultado.estadoTramite.numArchivo;
          this.controls = res.resultado.estadosLinea;
          this.dataSource = [];
          res.resultado.documentoTramites.forEach((element: any, index: number) => {
            this.dataSource.push ({
              //id: index++,
              id: element.id,
              descTipo: element.descTipoDocArchivo,
              docAdjunto: element.nombreArchivo,
              tieneDocumento: true,
              idBandeja: element.idBandeja,
              idBandejaDoc: element.idBandejaDoc,
              estadoDocumento: element.estadoDocumento,
              flagDocumentHabilitado: element.flagDocumentHabilitado
            });
          });

          console.log('this.estadoTramite: '+this.estadoTramite);
          if(this.estadoTramite==='TR006' || this.estadoTramite==='TR005'){
            this.flagImpresion= true;
          }

          if(this.estadoTramite==='TR005'){
            this.flagDisabledBoton= true;
          }else{
            this.flagDisabledBoton= false;
          }

          if(this.estadoTramite==='TR004'){
            this.flagEnviarRechazado= true;
          }
          console.log('flagImpresion: '+this.flagImpresion);
          console.log('flagEnviarRechazado: '+this.flagEnviarRechazado);

  /*        let dataLocal: any = {
            dl_nombreArchivoConvenio:this.nombreArchivoConvenio,
          };
          console.log("dataLocal", dataLocal);

          localStorage.setItem("dataLocal", JSON.stringify(dataLocal));
*/
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
   /* this.controls = [
      {
        titulo: "Solicitud registrada",
        fecha: "20/04",
        estado: "finalizado",
      },

      {
        titulo: "Pendiente de Pago",
        fecha: "20/04",
        estado: "actual",
      },
      {
        titulo: "Cuota Inicial",
        fecha: "20/04",
        estado: "faltante",
      },

    ];*/
  }

  loadValidaConsultaTramite() {
    const body = {
      numSuministro: this.nro_sumininstro,
      tipDocumento: this.tipo_documento,
      numDocumento: this.nro_documento,
      tipSolicitante: this.parentesco
    };
    console.log("body",body);
    this.financiamiento_service.getValidaConTramite(body).toPromise().then(
      response => {
        let existe = response.resultado;
        console.log("response.resultado.nExisteBand: ",response.resultado.nExisteBand);
        console.log("idBandeja: ",response.resultado.idBandeja);
        this.idBandeja=response.resultado.idBandeja;

        if (response.resultado.nExisteBand == 2) {
          this.globals.admin_msg_shared = 2;
          this.flag = true;
          this.flagBoton = false;
          this.titulo = "¡Bienvenido!";
          this.mensaje = "Ud. no cuenta con un financiamiento web en Proceso.";
        } else {
          if (response.resultado.nExisteBand == 1) {
            this.flag = false;
            this.flagBoton = false;
            this.titulo = "";
            this.mensaje = "";
            this.cargarData();
          } else {
            this.globals.admin_msg_shared = 2;
            this.flag = true;
            this.flagBoton = false;
            this.titulo = "¡Bienvenido!";
            this.mensaje = "Ud. no cuenta con un financiamiento en Proceso.";
          }
        }

        const bodyPDF = {
          clase: "FW_DIRECTORIO_TRABAJO",
          modulo: "ACUERDOS_WEB",
          categoria: "TAMANIO_ARCHIVO_MegaBytes_PDF"
        };
        this.financiamiento_service.getParametrosGc(bodyPDF).subscribe((response) => {
          this.limitFile_pdf = response.resultado.find((x) => x.categoria == "TAMANIO_ARCHIVO_MegaBytes_PDF").valor;
        });

        const bodyJPG = {
          clase: "FW_DIRECTORIO_TRABAJO",
          modulo: "ACUERDOS_WEB",
          categoria: "TAMANIO_ARCHIVO_MegaBytes_JPG"
        };
        this.financiamiento_service.getParametrosGc(bodyJPG).subscribe((response) => {
          this.limitFile_jpg = response.resultado.find((x) => x.categoria == "TAMANIO_ARCHIVO_MegaBytes_JPG").valor;
        });

      }
    ).catch(error=>{})
  }

  async verEvent(event: any) {

      console.log("id",event.id);
      console.log("docAdjunto",event.docAdjunto);

      const body = {
        nombreAchivo: event.docAdjunto
      };

      this.financiamiento_service
        .getDescargarArchivo(body)
        .toPromise()
        .then((response) => {
          console.log("response",response);
          console.log("response.resultado",response.resultado);
          console.log("response.resultado.flag",response.resultado.flag);
          if (response.resultado.flag) {

            let nombreArchivo    = response.resultado.fileName;
            let extensionArchivo = nombreArchivo.split(".").pop();
            console.log("nombreArchivo",nombreArchivo);
            console.log("extensionArchivo",extensionArchivo);

            if (extensionArchivo && extensionArchivo == "pdf") {

              //pdf
              const dialogRef = this.dialog.open(VisorDocumentosComponent, {
                data: {
                  src: `data:application/pdf;base64,${response.resultado.fileBase64}`,
                  nombre: response.resultado.fileName,
                  tipo: 'application/pdf',
                },
              });

            } else {

              //img
              const dialogRef = this.dialog.open(VisorDocumentosComponent, {
                data: {
                  src: `data:image/jpeg;base64,${response.resultado.fileBase64}`,
                  nombre: response.resultado.fileName,
                  tipo: 'image/jpeg',
                },
              });

            }

          } else {
            this.toastr.error("Ocurrió un problema al visualizar el documento. Inténtelo nuevamente.", "Atención", {
              closeButton: true,
            });
          }
      }).catch(error=>{
        console.log(error);
      });

  }

  async getBase64(file: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  adjuntarEvent(event: any) {

    // Validar que no excede la capacidad limite de los archivos
    let flagExcedido: boolean = false;
    let msjeExcedido: string = '';
    let factor: number = 1048576;
    let capacidad_PDF:number = factor * parseInt(this.limitFile_pdf);
    let capacidad_JPG:number = factor * parseInt(this.limitFile_jpg);

    console.log("capacidad_PDF",capacidad_PDF);
    console.log("capacidad_JPG",capacidad_JPG);

      console.log('NUEVO event.file.name.split(".")[0]: '+event.file.name.split(".")[1])

      let tipoExt = event.file.type === 'image/jpeg' ? 'jpg' : 'pdf';

      console.log('event.file.size: '+event.file.size);

      let sizeFile:number = event.file.size;


      if(tipoExt==='pdf'){

        if (capacidad_PDF < sizeFile) {
          flagExcedido = true;
          msjeExcedido="El documento adjunto ha excedido el límite máximo permitido para PDF: "+this.limitFile_pdf+" MB";
        } else {
          flagExcedido = false;
        }

      }else{

        if (capacidad_JPG < sizeFile) {
          flagExcedido = true;
          msjeExcedido="El documento adjunto ha excedido el límite máximo permitido para JPG: "+this.limitFile_jpg+" MB";
        } else {
          flagExcedido = false;
        }


      }

      if (flagExcedido) {
        this.toastr.warning(
          msjeExcedido,"Atención",
          { closeButton: true }
        );
      }else{

        console.log('event.file.name: '+event.file.name);
        console.log('NUEVO event.file.name.split(".")[0]: '+event.file.name.split(".")[0])
        console.log('ANTIGUO event.item.docAdjunto.split(".").pop(): '+event.item.docAdjunto.split(".").pop())
        console.log('event.item.idBandeja: '+event.item.idBandeja);
        console.log('event.item.idBandejaDoc: '+event.item.idBandejaDoc);
        let extensionNuevoArchivo=event.file.name.split(".").pop();
        let extensionAntiguoArchivo=event.item.docAdjunto.split(".").pop();
        let nombreArchivoAntiguo=event.item.docAdjunto.split(".")[0];

        let nuevoArchivo=nombreArchivoAntiguo.concat("."+extensionNuevoArchivo);
        console.log('nuevoArchivo: '+nuevoArchivo);

        this.dataSource.forEach(function (valueSource) {

          if (valueSource.idBandeja == event.item.idBandeja && valueSource.idBandejaDoc == event.item.idBandejaDoc) {
            valueSource.docAdjunto=nuevoArchivo;//este valor solo se queda en el temporal - vista
            valueSource.nombreArchivo=nuevoArchivo;//este valor va hasta la BD a actualizar el nombre
            valueSource.estadoDocumento='DC001';

          }
          console.log('valueSource.estadoDocumento: '+valueSource.estadoDocumento);

        })

      /*  for (var i = 0; i < this.dataSource.length; i++) {

          //si existe la bandeja en los documentos temporales
          if (this.dataSource[i].idBandeja == event.item.idBandeja &&
              this.dataSource[i].idBandejaDoc == event.item.idBandejaDoc) {
            console.log('EXISTE en TEMP');
            this.dataSource[i].docAdjunto=nuevoArchivo;
            i=this.dataSource.length;
          }

       }*/
        console.log('this.dataSource: '+this.dataSource);

          let formData: FormData = new FormData ();
          formData.append ('archivo', event.file, event.file.name);
          console.log('event.file.name: '+event.file.name);

          this.financiamiento_service.actualizarDocumentos (
            event.item.idBandeja,
            event.item.idBandejaDoc,
            event.item.docAdjunto,
            event.item.estadoDocumento,
            formData).toPromise ().then ((res: any) => {
              //this.dataSource = [];
              event.item.tieneDocumento = true;

              //this.cargarData();

              this.toastr.info(
                "Documento actualizado satisfactoriamente",
                "Confirmación",
                {
                  closeButton: true,
                }
              );

            }).catch ((error: any) => {
              console.log (error);
            });

      }



  }

  mostrarDialogo(event: any): void {
    this.dialog
      .open(DialogoConfirmacionComponent, {
        data: `¿Desea eliminar el documento seleccionado?`
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          event.tieneDocumento = false;
          event.estadoDocumento='DC003';
          this.toastr.info(
              "Documento eliminado satisfactoriamente",
              "Confirmación",
              {
                closeButton: true,
              }
            );
        }
    });
  }

  eliminarEvent(event: any) {

    this.mostrarDialogo(event);
      //event.docAdjunto = "";
  /*    event.tieneDocumento = false;

      this.toastr.info(
        "Documento eliminado satisfactoriamente",
        "Confirmación",
        {
          closeButton: true,
        }
      );*/
/*
    const bodyDelete = {
      idBandeja: event.idBandeja,
      idBandejaDoc: event.idBandejaDoc,
      nombreArchivo: event.docAdjunto,
      estadoDocumento: event.estadoDocumento
    };
    console.log("bodyDelete",bodyDelete);
    this.financiamiento_service.eliminarDocumentos(bodyDelete).toPromise ().then ((res: any) => {
      //this.dataSource = [];
      this.ngOnInit ();
      }).catch ((error: any) => {
        console.log (error);
      });*/
  }


  toggleDocumentos() {
    this.verDocumentos = !this.verDocumentos;
  }

  get_datetime_format (datetime: any, format: string) {
    return moment (datetime).format (format);
  }

  descargarConvenio(){
//    this.dataLocal = JSON.parse (localStorage.getItem ('dataLocal'));
 //   this.data = JSON.parse (localStorage.getItem ('data'));
 //   console.log("this.dataLocal.dl_nombreArchivoConvenio: "+this.dataLocal.dl_nombreArchivoConvenio);
 this.nombreArchivoConvenio
    console.log("this.idBandeja: "+this.idBandeja);
    console.log("this.nombreArchivoConvenio: "+this.nombreArchivoConvenio);
    console.log("this.data.suministro: "+this.data.suministro);
    console.log("this.data.tipo_documento: "+this.data.tipo_documento);
    console.log("this.data.numero_documento: "+this.data.numero_documento);
    console.log("this.correo_solicitante: "+this.correo_solicitante);

    if (this.nombreArchivoConvenio) {

      //nisrad_secnis_numacu.pdf
      this.financiamiento_service
      .descargarConvenio(
        this.nombreArchivoConvenio,//this.nombreArchivoConvenio,
          this.idBandeja,
          this.data.suministro,
          this.data.tipo_documento,
          this.data.numero_documento,
          this.correo_solicitante
      )
      .toPromise()
      .then((response) => {
        console.log("response.flag: ",response.resultado.flag);
        console.log("response.fileName: ",response.resultado.fileName);
        console.log("response.fileBase64: ",response.resultado.fileBase64);

        if (response.resultado.flag) {

          let nombreArchivo    = response.resultado.fileName;
          this.dowloadPDF(response.resultado.fileBase64,nombreArchivo);

          this.toastr.info(
            "Su convenio se descargó con éxito",
            "Confirmación",
            {
              closeButton: true,
            }
          );

          this.cargarData();


        } else {
          this.toastr.error("Error al descargar su convenio, Inténtelo nuevamente.", "Atención", {
            closeButton: true,
          });
        }
    }).catch(error=>{
      console.log(error);
    });

  } else {
      let data = JSON.parse (localStorage.getItem ('data'));
      console.log("data.nis_rad "+data.suministro);
    }




  }


  dowloadPDF(pdf: any, nombreFile: any){
    const linkSource =`data:application/pdf;base64,${pdf}`;
    const downloadLink=document.createElement("a");
    const fileName=nombreFile;

    downloadLink.href=linkSource;
    downloadLink.download=fileName;
    downloadLink.click();

   }



   enviarRechazado(){

     let flagEnviarRechazado: boolean = true;
    this.dataSource.forEach(function (valueSource) {

      console.log('valueSource.idBandeja: '+valueSource.idBandeja);
      console.log('valueSource.idBandejaDoc: '+valueSource.idBandejaDoc);
      console.log('valueSource.docAdjunto: '+valueSource.docAdjunto);
      if(valueSource.estadoDocumento=='DC003'){
        flagEnviarRechazado=false;
      }

    })

    console.log('flagEnviarRechazado: '+flagEnviarRechazado);

    if(flagEnviarRechazado){
            const requestSolicitante = {
              suministro: this.nro_sumininstro,
              nombres   : this.nombres,
              apellidos: this.apellidos,
              descTipDoc : this.desc_tip_docum,
              numeDocumento: this.nro_documento,
              telefono: this.telefono,
              celular: this.celular,
              correo: this.correo,
              codiOficina:this.codOficina,
              documentos: this.dataSource

            };
            //nisrad_secnis_numacu.pdf
            this.financiamiento_service
            .enviarRechazado(this.idBandeja, requestSolicitante)
            .toPromise()
            .then((ResponseBack) => {
              console.log("ResponseBack.resultado.retorno: ",ResponseBack.resultado.retorno);
              console.log("ResponseBack.resultado.mensaje: ",ResponseBack.resultado.mensaje);
              if (ResponseBack.resultado.retorno==0) {

                this.toastr.info(
                  "Sus documentos se enviaron con éxito",
                  "Confirmación",
                  {
                    closeButton: true,
                  }
                );

                //this.cargarData();
                this.globals.admin_msg_shared = 1;
                this.router.navigate(["/mensaje-financiamiento"]);
                return;

              }else if (ResponseBack.resultado.retorno==1) {

                this.toastr.error(ResponseBack.resultado.mensaje, "Atención", {
                  closeButton: true,
                });

              }else if (ResponseBack.resultado.retorno==2) {

                this.toastr.error(ResponseBack.resultado.mensaje, "Atención", {
                  closeButton: true,
                });

            }else {
                this.toastr.error("No se logró actualizar la bandeja. Inténtelo nuevamente.", "Atención", {
                  closeButton: true,
                });
              }
          }).catch(error=>{
            console.log(error);
          });


        }else{

            this.toastr.warning(
              "Es obligatorio que actualice los documentos rechazados",
              "Confirmación",
              {
                closeButton: true,
              }
            );

        }

  }

}
